import React from 'react';

const LoginBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-muted/30" />
      
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-primary/5 rounded-full blur-xl" />
      <div className="absolute top-40 right-20 w-24 h-24 bg-secondary/5 rounded-full blur-lg" />
      <div className="absolute bottom-32 left-20 w-40 h-40 bg-accent/5 rounded-full blur-2xl" />
      <div className="absolute bottom-20 right-10 w-28 h-28 bg-primary/5 rounded-full blur-lg" />
      
      {/* Grid Pattern */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, var(--color-foreground) 1px, transparent 0)`,
          backgroundSize: '24px 24px'
        }}
      />
    </div>
  );
};

export default LoginBackground;